
import { Dialog, DialogContent, useTheme } from "@material-ui/core"
import React from "react"
import CreateUserModal from "./FormsUsers/createUsers";
import { DialogTitle, Transition } from "../../../utils/DialogTitle";
import EditUserModal from "./FormsUsers/editUsers";

export default function ModalUsers({ setopenMondal, isOpen, isEdit, data, reload }) {
  

    const handleClose = () => {
        clearData();
    };

    const clearData = () => {
        setopenMondal(false);
    };
    const theme = useTheme(); // Obtén el tema

    const primaryColor = theme.palette.primary.main;

    return (
        <>
            <div>
                <Dialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={isOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    style={{ maxHeight: "500%" }}
                    fullWidth={true}
                    maxWidth="xs"
                >
                   <DialogTitle id="customized-dialog-title" onClose={(e) => { clearData() }}>
                        {isEdit ? `Editar usuarios` : `Crear usuarios`}
                    </DialogTitle>
                    <DialogContent style={{ paddingBottom: '30px' }}>
                        {isEdit ?
                            (

                                <EditUserModal data={data} clearData={clearData} reload={reload} primaryColor={primaryColor}/>
                            )
                            :
                            (

                                <CreateUserModal reload={reload} clearData={handleClose} primaryColor={primaryColor}/>
                            )

                        }

                    </DialogContent>
                </Dialog>
            </div>
        </>
    )
}